var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1129,
    height: 998,
    viewBox: "0 0 1129 998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.818 229.109L336.54 269.053L173.021 174.187L244.795 134.243L405.818 229.109Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.818 440.061L336.54 480.005L173.021 385.139L244.795 345.195L405.818 440.061Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.423 440.061L336.146 480.005L172.627 385.139L244.401 345.195L405.423 440.061Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.541 269.054V480.006",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.418 134.243V345.195L173.09 385.069V174.117",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405.816 228.416V439.368",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.911 307.054L198.634 346.998L35.1152 252.132L106.889 212.188L267.911 307.054Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.911 518.007L198.634 557.95L35.1152 463.084L106.889 423.141L267.911 518.007Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.519 518.007L198.242 557.95L34.7227 463.084L106.496 423.141L267.519 518.007Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.637 346.999V557.951",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.514 212.188V423.14L35.1855 463.015V252.063",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.912 306.361V517.313",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M847.523 334.586L778.246 374.529L614.727 279.663L686.5 239.72L847.523 334.586Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M847.523 545.538L778.246 585.481L614.727 490.615L686.5 450.672L847.523 545.538Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M847.128 545.538L777.851 585.481L614.332 490.615L686.106 450.672L847.128 545.538Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M778.246 374.528V585.48",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M687.123 239.72V450.672L614.795 490.546V279.594",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M847.523 333.893V544.845",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062.19 453.605L992.915 493.549L829.396 398.683L901.17 358.739L1062.19 453.605Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.19 664.557L992.915 704.501L829.396 609.635L901.17 569.691L1062.19 664.557Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.8 664.557L992.523 704.501L829.004 609.635L900.778 569.691L1061.8 664.557Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.918 493.55V704.502",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.795 358.739V569.691L829.467 609.565V398.614",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.19 452.912V663.864",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M462.145 191.914L531.422 231.857L694.941 136.991L623.167 97.0479L462.145 191.914Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M462.145 402.867L531.422 442.81L694.941 347.945L623.167 308.001L462.145 402.867Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M462.539 402.867L531.816 442.81L695.335 347.945L623.562 308.001L462.539 402.867Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M531.422 231.858V442.81",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M622.543 97.0479V308L694.871 347.874V136.922",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M462.145 191.222V402.174",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.684 96.866L378.961 136.81L542.48 41.9436L470.706 2L309.684 96.866Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.684 307.818L378.961 347.762L542.48 252.896L470.706 212.952L309.684 307.818Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.076 307.818L379.353 347.762L542.872 252.896L471.099 212.952L310.076 307.818Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.963 136.811V347.763",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.082 2V212.952L542.41 252.826V41.8742",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.684 96.1729V307.125",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.555 744.818L541.832 784.762L705.351 689.896L633.577 649.952L472.555 744.818Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.555 955.77L541.832 995.714L705.351 900.848L633.577 860.904L472.555 955.77Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.947 955.77L542.224 995.714L705.743 900.848L633.97 860.904L472.947 955.77Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.834 784.763V995.715",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.953 649.952V860.904L705.281 900.778V689.826",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.555 744.125V955.077",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336.541 650.208L405.818 690.151L569.337 595.285L497.564 555.342L336.541 650.208Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336.541 861.16L405.818 901.104L569.337 806.238L497.564 766.294L336.541 861.16Z",
    stroke: "#231F20",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M336.934 861.16L406.211 901.104L569.73 806.238L497.956 766.294L336.934 861.16Z",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M405.816 690.15V901.102",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M496.939 555.342V766.294L569.268 806.168V595.216",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.541 649.514V860.466",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.541 220.072L1102.68 814.444",
    stroke: "white",
    strokeWidth: 26.0335,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.025 744.293L747.862 871.234L228.197 569.75L456.294 442.809L968.025 744.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 697.956L245.097 571.016",
    stroke: "white",
    strokeWidth: 26.0335,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2126 648.808L17 696.347L66.0605 712.7",
    stroke: "white",
    strokeWidth: 26.0335,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.68 831.095L1113 818.592L1100.65 768.374",
    stroke: "white",
    strokeWidth: 26.0335,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.233 195.511L80.7109 215.984L101.353 263.4",
    stroke: "white",
    strokeWidth: 26.0335,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M844.932 618.646L547.473 793.466",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10,
    strokeDasharray: "8.98 8.98"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M650.962 511.388L557.447 566.347",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10,
    strokeDasharray: "8.98 8.98"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M747.069 673.246L367.824 461.185",
    stroke: "white",
    strokeWidth: 3.25419,
    strokeMiterlimit: 10,
    strokeDasharray: "8.98 8.98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.39675230ab99877a3134bb5a9c4c6a56.svg";
export { ForwardRef as ReactComponent };